import { useQuery } from "@tanstack/react-query";
import PermissionService from "services/PermissionService";
import UserService from "services/UserService";
const usePermissionsQuery = () => {
  const isAuthenticated = UserService.isAuthenticated();

  return useQuery({
    queryKey: ["permissions"],
    queryFn: PermissionService.getUserPermissions,
    staleTime: 1000*60,
    select: (data: any) => data.permissions,
    enabled: isAuthenticated
  });
};

// Hook to check specific resource permission
export const useHasPermission = (resource: string) => {
  const { data, isLoading, error } = usePermissionsQuery();
  const hasPermission =
    data?.some(permission => permission.resource === resource) ??
    false;

  return {
    isAllowed: hasPermission,
    isLoading,
    error
  };
};

// Define allowed permission actions

export const PermissionAction = {
  MANAGE: "manage" as const,
  VIEW: "view" as const
} as const;

export type PermissionActionType =
  (typeof PermissionAction)[keyof typeof PermissionAction];

// Hook to check specific resource-action permission
export const useHasActionPermission = (
  resource: string,
  action: PermissionActionType
) => {
  const { data, isLoading, error } = usePermissionsQuery();

  const hasPermission =
    data?.some(
      permission =>
        permission.resource === resource && permission.action === action
    ) ?? false;

  return {
    isAllowed: hasPermission,
    isLoading,
    error
  };
};
